import type { ValidProperties } from '@wmgone/analytics';

import type { Brand } from '~/modules/branding/types';

/**
 * Returns an object containing default User properties for Analytics tracking.
 * These properties will be used at the User level only and not included with
 * each event that is tracked.
 * @param brand - The Brand object to get information from.
 * @returns Properties to be used at the User level of the Analytics tracking.
 */
export function getDefaultUserProperties(brand: Brand) {
  const properties: ValidProperties = {};

  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  //
  //    ▄▄▄▖  ▗▖  ▗▖  ▗▄▄▖   ▗▄▖  ▗▄▄▖  ▗▄▄▄▖  ▗▄▖  ▗▖  ▗▖  ▗▄▄▄▖   ▐▌
  //     █    ▐▛▚▞▜▌  ▐▌ ▐▌ ▐▌ ▐▌ ▐▌ ▐▌   █   ▐▌ ▐▌ ▐▛▚▖▐▌    █     ▐▌
  //     █    ▐▌  ▐▌  ▐▛▀▘  ▐▌ ▐▌ ▐▛▀▚▖   █   ▐▛▀▜▌ ▐▌ ▝▜▌    █     ▐▌
  //    ▄█▄▖  ▐▌  ▐▌  ▐▌    ▝▚▄▞▘ ▐▌ ▐▌   █   ▐▌ ▐▌ ▐▌  ▐▌    █     ▗▖
  //
  //    These properties are used to identify the User in Amplitude.
  //
  //    DO NOT REMOVE ANYTHING FROM HERE WITHOUT FIRST CHECKING WITH THE TEAM!
  //
  //    At a bare mininm ask in the relevant channel (#ada-wmg1-amplitude-collab)
  //    so that everyone is aware of the potential change.
  //
  //    These values are more than likely being used for analytics and any
  //    changes can have huge effects on the data being collected/reported.
  //
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  // NOTE: is_wmg1_user / is_ada_user should NEVER be set to false. These
  //       values will be used in the analytics to create cohorts of users.
  //       They effectively represent if a user has used a particular product
  //       in the past. So once set, they stay set.
  if (brand.product === 'WMG1') {
    properties.is_wmg1_user = true;
  }

  if (brand.product === 'ADA') {
    properties.is_ada_user = true;
  }

  return properties;
}
